<template>
  <transition name="transition-slide-right">
    <SideStockInfo v-if="showSideStockView" />
  </transition>
</template>
<script>
import SideStockInfo from './SideStockInfo'
export default {
  name: 'SideStockView',
  components: {
    SideStockInfo
  },
  computed: {
    showSideStockView() {
      return this.$store.getters.isShowSideStockView
    }
  }
}
</script>
